module.exports = __webpack_public_path__ + "img/rush_logo.079cfa26.webp";